import React from "react";
import styled from "styled-components";
import {useLocale} from "../../shared/context/AppContext";
import useTranslation from "../../shared/utils/translation";

const FooterSectionWrapper = styled.section`
  padding: 1rem 2rem;
  font-size: 14px;
`;

const Title = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  margin-bottom: 0.3rem;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

function FooterSection() {
  const t = useTranslation()
  const {language} = useLocale()
  const lang = (language || "en").toUpperCase()

  return (
    <FooterSectionWrapper>
      <Title>{t("common.termsTitle")}</Title>
      <List>
        <ListItem>
          <a href={`/static/docs/IML_${lang}.pdf`} target="_blank" rel="noopener noreferrer">
            {t("common.tos")} ↗
          </a>
        </ListItem>
      </List>
    </FooterSectionWrapper>
  );
}

export default FooterSection
